var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16699 1.04175C4.67968 1.04175 1.04199 4.67943 1.04199 9.16675C1.04199 13.6541 4.67968 17.2917 9.16699 17.2917C11.1857 17.2917 13.0324 16.5556 14.4534 15.337L17.8917 18.7754C18.1358 19.0194 18.5315 19.0194 18.7756 18.7754C19.0197 18.5313 19.0197 18.1356 18.7756 17.8915L15.3373 14.4531C16.5558 13.0322 17.292 11.1854 17.292 9.16675C17.292 4.67943 13.6543 1.04175 9.16699 1.04175ZM2.29199 9.16675C2.29199 5.36979 5.37003 2.29175 9.16699 2.29175C12.964 2.29175 16.042 5.36979 16.042 9.16675C16.042 12.9637 12.964 16.0417 9.16699 16.0417C5.37003 16.0417 2.29199 12.9637 2.29199 9.16675Z",
    fill: "#A0A2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.3f4d3f25e2bb3394592fcd9efc6f3908.svg";
export { ForwardRef as ReactComponent };